import type { ClientErrorReport, SystemStatus } from '@ridemaadi/types';

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api';
const reported = new Set<string>();

function fingerprint(kind: string, message: string): string {
  return `${kind}:${message.slice(0, 120)}`;
}

/** Fetch public maintenance / operational status. */
export async function fetchSystemStatus(): Promise<SystemStatus> {
  const res = await fetch(`${BASE_URL}/system/status`, { credentials: 'include' });
  if (!res.ok) throw new Error('status_unavailable');
  const json = (await res.json()) as { ok: boolean; data: SystemStatus };
  if (!json.ok) throw new Error('status_unavailable');
  return json.data;
}

/** Report a client-side error to the admin console (fire-and-forget). */
export function reportClientError(report: ClientErrorReport): void {
  const key = fingerprint(report.kind, report.message);
  if (reported.has(key)) return;
  reported.add(key);

  void fetch(`${BASE_URL}/system/errors`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...report,
      url: report.url ?? window.location.href,
    }),
  }).catch(() => {
    /* swallow - error reporter must not throw */
  });
}

export function isAdminPath(pathname = window.location.pathname): boolean {
  return pathname === '/admin' || pathname.startsWith('/admin/');
}
